module.exports = __webpack_public_path__ + "static/birdFeeder-c9f81c4bc82d79b29b8773b1c0c53a2a.jpg";